/**
 * /gazduire-web — migrated from public/js/hosting.js.
 *
 * 1. Sticky-bookmarks (shared)
 * 2. .layer-1 .col i + .layer-5 i Tooltip
 * 3. .layer-1 .col click → .featured
 * 4. header.b-hosting .switch-btn — fork: switch-plans (.packages fade) sau
 *    switch-sums (.sum fade)
 * 5. .packages popup + info tabs (shared)
 * 6. .layer-5 a.btn-more — show .row-more
 */
import { Resort } from '../core/resort.js';
import { initStickyBookmarks } from '../shared/sticky-bookmarks.js';
import { initPackagesInfo } from '../shared/packages-info.js';

new Resort(() => {
    initStickyBookmarks();

    ($('.layer-1 .col i', true) as NodeListOf<Element>).Tooltip();
    ($('.layer-5 i', true) as NodeListOf<Element>).Tooltip();

    ($('.layer-1 .col', true) as NodeListOf<Element>).on('click', function (this: Element) {
        (this.parentElement?.find('.featured') as Element | null)?.classList.remove('featured');
        this.classList.add('featured');
    });

    /* Switch button — handle 2 cases: switch-plans (packages) sau .sum fade */
    let switchReady = true;
    ($('header.b-hosting .switch-btn', true) as NodeListOf<Element>).on('click', 'a', function (this: Element, e: Event) {
        if (this.classList.contains('active') || !switchReady) return;
        switchReady = false;
        ($('header.b-hosting .switch-btn a.active') as Element | null)?.classList.remove('active');
        this.classList.add('active');

        const targetId = (this as HTMLElement).dataset['id'];
        const currentTarget = e.currentTarget as Element;

        if (currentTarget.classList.contains('switch-plans')) {
            ($('.packages:not(.hide)') as HTMLElement | null)?.dxFadeOut((t: HTMLElement) => t.classList.add('hide'));
            ($(`.packages[data-id="${targetId}"]`) as HTMLElement | null)?.dxFadeIn(() => { switchReady = true; });
            return;
        }

        $('.layer-1 .row .sum.active', (active: Element) => {
            active.classList.add('fade-out-fast');
            active.addEventListener('animationend', function (this: Element, ev: Event) {
                ev.stopPropagation();
                this.classList.remove('active', 'fade-out-fast');
                switchReady = true;
            }, { once: true });
            return true;
        });
        $(`.layer-1 .row .sum[data-id="${targetId}"]`, (layer: Element) => {
            layer.classList.add('active', 'fade-in-fast');
            layer.addEventListener('animationend', function (this: Element, ev: Event) {
                ev.stopPropagation();
                this.classList.remove('fade-in-fast');
                switchReady = true;
            }, { once: true });
            return true;
        });
    });

    initPackagesInfo();

    ($('.layer-5 a.btn-more') as Element | null)?.on('click', function (this: Element) {
        (this as HTMLElement).style.display = 'none';
        const rowMore = $('.row-more') as HTMLElement | null;
        if (rowMore) rowMore.style.display = 'table-row-group';
    });
});
